module.exports = __webpack_public_path__ + "img/04_map.f16a0d02.webp";